import Component from '@glimmer/component';
import { LinkTo } from '@ember/routing';
import { hash } from '@ember/helper';
import { eq } from '../helpers/article-type';

export default class Pagination extends Component {
  get currentPage() {
    return this.args.currentPage || 1;
  }

  get totalPages() {
    const total = this.args.total || this.args.totalCount || 0;
    const limit = this.args.limit || this.args.perPage || 10;
    return Math.ceil(total / limit);
  }

  get hasPrevious() {
    return this.args.hasPreviousPage !== undefined
      ? this.args.hasPreviousPage
      : this.currentPage > 1;
  }

  get hasNext() {
    return this.args.hasNextPage !== undefined
      ? this.args.hasNextPage
      : this.currentPage < this.totalPages;
  }

  get previousPage() {
    return Math.max(1, this.currentPage - 1);
  }

  get nextPage() {
    return Math.min(this.totalPages, this.currentPage + 1);
  }

  get showPagination() {
    return this.totalPages > 1;
  }

  get visiblePages() {
    const current = this.currentPage;
    const total = this.totalPages;
    const pages = [];

    if (total <= 7) {
      // Show all pages if 7 or fewer
      for (let i = 1; i <= total; i++) {
        pages.push(i);
      }
    } else {
      // Always show first page
      pages.push(1);

      if (current <= 3) {
        // Near start: show 1, 2, 3, 4, ..., last
        pages.push(2, 3, 4);
        pages.push('ellipsis-end');
        pages.push(total);
      } else if (current >= total - 2) {
        // Near end: show 1, ..., last-3, last-2, last-1, last
        pages.push('ellipsis-start');
        pages.push(total - 3, total - 2, total - 1, total);
      } else {
        // In middle: show 1, ..., current-1, current, current+1, ..., last
        pages.push('ellipsis-start');
        pages.push(current - 1, current, current + 1);
        pages.push('ellipsis-end');
        pages.push(total);
      }
    }

    return pages;
  }

  <template>
    {{#if this.showPagination}}
      <div class='page-navigation blue spaced'>
        {{#if this.hasPrevious}}
          <LinkTo 
            @route={{@route}} 
            @query={{hash page=this.previousPage}}
            class='slider-control big control-previous'
          >
            <svg class='arrow-icon medium'>
              <use href='#svg-arrow-medium'></use>
            </svg>
          </LinkTo>
        {{else}}
          <div class='slider-control big control-previous disabled'>
            <svg class='arrow-icon medium'>
              <use href='#svg-arrow-medium'></use>
            </svg>
          </div>
        {{/if}}

        {{#each this.visiblePages as |page|}}
          {{#if (eq page 'ellipsis-start')}}
            <span class='page-navigation-item'>...</span>
          {{else if (eq page 'ellipsis-end')}}
            <span class='page-navigation-item'>...</span>
          {{else if (eq page this.currentPage)}}
            <span class='page-navigation-item active'>{{page}}</span>
          {{else}}
            <LinkTo
              @route={{@route}}
              @query={{hash page=page}}
              class='page-navigation-item'
            >
              {{page}}
            </LinkTo>
          {{/if}}
        {{/each}}

        {{#if this.hasNext}}
          <LinkTo 
            @route={{@route}} 
            @query={{hash page=this.nextPage}}
            class='slider-control big control-next'
          >
            <svg class='arrow-icon medium'>
              <use href='#svg-arrow-medium'></use>
            </svg>
          </LinkTo>
        {{else}}
          <div class='slider-control big control-next disabled'>
            <svg class='arrow-icon medium'>
              <use href='#svg-arrow-medium'></use>
            </svg>
          </div>
        {{/if}}
      </div>
    {{/if}}
  </template>
}